import userService from '../../../services/userService';
import windowService from '../../../services/windowService';
import type { User } from '../../authentication';
import type { UserOrg } from '../models/userOrg';

type SessionOrgUser = Pick<User, 'userId' | 'lastSelectedAccount'>;

/**
 * If this is a white-label domain and the user isn't on that org, switch (or 401).
 * Returns true when a redirect was issued.
 */
export function syncWhiteLabelOrg(loadedOrgs: UserOrg[], currentUser: SessionOrgUser): boolean {
  if (!currentUser.userId) {
    return false;
  }

  const whiteLabelOrgId = window.getWhiteLabelOrgId?.();
  if (!whiteLabelOrgId || currentUser.lastSelectedAccount === whiteLabelOrgId) {
    return false;
  }

  const userHasOrgId = (orgId: string) => loadedOrgs.some(orgItem => orgItem._id.id === orgId);

  if (userHasOrgId(whiteLabelOrgId)) {
    userService.switchOrg(currentUser.userId, whiteLabelOrgId);
    window.localStorage.setItem('newHash', '/dashboard');
    windowService.redirectTo('/dashboard');
  } else {
    window.localStorage.setItem('is401', 'true');
    window.localStorage.setItem('newHash', '/401');
    windowService.redirectTo('/401');
  }

  return true;
}
